const activeHotMarkets = window.mivaJS.ActiveHotMarkets;
// eslint-disable-next-line array-element-newline, object-property-newline
const backgroundFilters = window.mivaJS?.Searchspring_Background_Filters ?? [];
const availgroups = window.mivaJS?.availgroups || [];

export const rallyHouseFilters = (client) => {
	// Apply background filter to exclude "currently_unavailable" items.
	client.backgroundFilter('currently_unavailable', 'no');

	// Apply background filter to exclude "hot_market" items
	client.backgroundFilter('hot_market', 'no');

	// Add Active Hot Market filters
	for (let hotmarket of activeHotMarkets) {
		client.backgroundFilter('hot_market', hotmarket.value);
	}

	// Add Availability Groups filters
	for (let availgroup of availgroups) {
		client.backgroundFilter('availability_groups', availgroup);
	}

	// Apply global background filters
	for (const filter of backgroundFilters) {
		if (Array.isArray(filter.value)) {
			for (let value of filter.value) {
				client.backgroundFilter(filter.field, value);
			}
		}
		else {
			client.backgroundFilter(filter.field, filter.value);
		}
	}
};

export const rallyHouseFiltersAutocomplete = (params) => {
	// Apply background filter to exclude "currently_unavailable" items.
	params['bgfilter.currently_unavailable'] = 'no';

	// Apply background filter to exclude "hot_market" items
	params['bgfilter.hot_market'] = ['no'];

	// Add Active Hot Market filters
	for (let hotmarket of activeHotMarkets) {
		params['bgfilter.hot_market'].push(hotmarket.value);
	}

	// Add Availability Groups filters
	if (availgroups.length) {
		params['bgfilter.availability_groups'] = [];

		for (let availgroup of availgroups) {
			params['bgfilter.availability_groups'].push(availgroup);
		}
	}

	// Apply global background filters
	for (const filter of backgroundFilters) {
		params[`bgfilter.${filter.field}`] = Array.isArray(filter.value)
			? filter.value
			: [filter.value];
	}
};
